import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { apiUri } from '@/constants/Constants';
import { DealsDashboardClient } from '@/shared/api';
import type { DealTypeCounts } from './application.types';

export type GetDealTypeCountsResponse = {
  data: {
    count_by_type: DealTypeCounts;
  };
};

const getDealTypeCounts = async (includeExpiredDeals: boolean): Promise<DealTypeCounts> => {
  const response = await DealsDashboardClient.post<GetDealTypeCountsResponse>(
    apiUri.getApplicationTabCounts,
    // Only sent when on, so the default request body is unchanged.
    includeExpiredDeals ? { filters: { include_expired_deals: true } } : {},
  );

  return response.data.data.count_by_type;
};

/**
 * Tab badge counts. `includeExpiredDeals` widens the Expiring Soon bucket to bonds that
 * expired long ago, matching that tab's toggle — the badge has to count what the table shows.
 * It is part of the query key, so the two states cache independently rather than one
 * overwriting the other under `staleTime: Infinity`.
 */
export const useDealTypeCounts = (includeExpiredDeals = false) =>
  useQuery({
    queryKey: ['deal-type-counts', includeExpiredDeals],
    queryFn: () => getDealTypeCounts(includeExpiredDeals),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
